<template>
  <div 
 class="belfast-form"   id="site-upload-form"
    :style="(type != undefined && isMobileDevice() == false) ? type.customStyle: ''"
  >
    

    <div id="create-site-layer" >
     
        <div id="vue-stepper">        
        <stepper v-model="steps">
          <div class="jumbotron" slot="test">

      <form>
        <div>
          <ul class="collapsible form-collapsible" v-for="(step, index) in steps">
            <li v-for="(group, index) in fieldGroupsFilterSlug" :key="index" class='active' v-if="step.slug==group.step" v-show="showHideGroups(group.slug, formFields)">
              <div class="collapsible-header">
                <div class="row" style="margin-bottom:0">
                   <div class="column gName">
                        {{group.name}}
                    </div>
                    <!-- <div class="column" style="float: right;color:#2ec4b6">
                        {{countGroupFields(group.slug, formFields)}}
                    </div> -->
                  </div>
              </div>

              <div class="collapsible-body" style="display: block;">
                <div class="collapsible-body-wrapper">
                  <div v-for="field in groupFormFields(group.slug, formFields)" :key="field.name">
                    <div v-if="field.type == 'id'" class="input-field" v-show="field.enabled">
                      <label :for="field.name">{{field.displayName}}</label>
                      <div>{{field.value}}</div>
                    </div>
                    <div v-if="field.type == 'date'" class="input-field" v-show="field.enabled">
                      <label :for="field.name">{{field.displayName}}</label>
                      <span class="required" v-if="field.requiredField">*</span>
                      <datepicker :format="'dd/MM/yyyy'" placeholder="Select Date" v-model="field.value"></datepicker>
                    </div>
                    <div v-if="field.type == 'string' || field.type == 'geojsonlarge'" class="input-field" v-show="field.enabled">
                      <label :for="field.name">{{field.displayName}}</label>
                      <span class="required" v-if="field.requiredField">*</span>
                      <input :id="field.name" type="text" v-model="field.value" />
                    </div>
                    <div v-if="field.type == 'video'" class="input-field" v-show="field.enabled">
                      <label :for="field.name">{{field.displayName}}</label>
                      <div class="input-field--nested">
                        <label>Url</label>
                        <input :id="field.name" type="text" v-model="field.value.url" />
                      </div>
                      <div class="input-field--nested">
                        <label>Auto Play</label>
                        <input :id="field.name+'-autoplay'" type="checkbox" v-model="field.value.autoplay" />
                      </div>
                    </div>
                  
                    <div v-if="field.type == 'hidden'" class="input-field" style="display:none">
                      <input readonly :id="field.name" type="hidden" v-model="field.value" />
                    </div>
                    <div v-if="field.type == 'password'" class="input-field" v-show="field.enabled">
                      <label :for="field.name">{{field.displayName}}</label>
                      <span class="required" v-if="field.requiredField">*</span>
                      <input :id="field.name" type="password" v-model="field.value" />
                    </div>
                    <div v-if="field.type == 'dropdown'" class="input-field" v-show="field.enabled">
                      <label :for="field.name">{{field.displayName}}</label>
                      <span class="required" v-if="field.requiredField">*</span>
                      <select class="browser-default" v-model="field.value">
                        <option
                                  v-for="option in field.values"
                                  :key="option.index"
                                  :value="option.value"
                                >{{option.name}}</option>
                      </select>
                    </div>
                    <div v-if="field.type == 'agree'" id="terms"><input  type="checkbox" onclick="agree()" name="terms" value="on" /><span> {{field.displayName}}</span></div>
                     <table v-if="field.type == 'rank'" class="input-field newRadio" v-show="field.enabled">
                      <tbody>
                        <tr>
                          <td width=100%><label class="rankLabel" :for="field.name">{{field.displayName}}</label></td>
                        </tr>
                        <tr>
                          <td width=100%>
                                <!-- <div class="rank-desc-up">
                                  <div><i class="fas fa-thumbs-up"></i></div>
                                  <div></div>
                                  <div class="no-opt"><i class="fas fa-thumbs-down"></i></div>
                                </div> -->
                              <vue-slider
                                  v-bind="vueSliderOptions"
                                  :min="A"
                                  :max="E"
                                  v-model="field.value"
                                  :interval="1"
                                  :marks="true"
                                  :hide-label="true"
                                  class="vue-slider-component"
                                  
                                  >
                                </vue-slider>
                               
                                <!-- <div class="rank-desc-6">
                                  <div class="no-opt">{{field.values.minDesc}}</div>
                                  <div>{{field.values.maxDesc}}</div>
                                </div> -->
                           </td>
                        </tr>
                      </tbody>
                    </table>
                   
                    <div v-if="field.type == 'checkboxbutton'" class="input-field">
                        <label :for="field.name" class="thicklabel">{{field.displayName}}</label>
                      
                        <span class="required" v-if="field.requiredField">*</span>
                        <div :id="field.name  + '_check'" class="checkbox_button_flex t_caption">
                          <div class="checkboxbutton" v-for="(item,index) in field.values" v-bind:key="item.value" :id="index"> 
                          <label :for="index + '_check'">
                            <input
                              type="checkbox"
                              :id="index + '_check'"
                              :value="item.value"
                              v-model="field.value"
                              :disabled="field.value.length > 4 && field.value.indexOf(item.value)===-1"
                            />
                            <span class="checkmark" :id="index">{{item.name}} </span>
                          </label>
                          </div>
                        </div>
                      </div>


                    <div v-if="field.type == 'checkbox'" class="input-field" v-show="field.enabled">
                      <label :for="field.name" class="thicklabel">{{field.displayName}}</label>
                      <span class="required" v-if="field.requiredField">*</span>
                      <span class="helper-icon" v-if="field.helpField">
                        <i class="material-icons" @click="toggleHelper(field.name)">info_outline</i>
                      </span>

                      <div class="helper-msg" :ref="field.name" v-if="field.helpField">
                        <div class="card-panel teal" v-html="field.helpField"></div>
                      </div>

                      <div :id="field.name  + '_check'" class="checkbox t_caption">
                        <div v-for="(item) in field.values" v-bind:key="item.value">
                          <label class="checkbox-container"> 
                          {{item.name}}
                          <input
                            type="checkbox"
                            :id="item.value + '_check'"
                            :value="item.value"
                            v-model="field.value"
                          />
                          <span class="checkmark" :id="item.value"></span>
                          </label>
          
                          <input  :id="item.value + '_other'" v-model="field.commentValue" type="text" placeholder="Enter your comment here..." v-if="item.name == 'Other' && field.value.includes('Comments')" />
                        </div>
                      </div>
                      <div v-show="field.comments">
                        <input :id="field.name + '_comments'" :name="field.name + '_comments'" v-model="field.commentValue" type="text"  />
                      </div>
                    </div>
                    <div v-if="field.type == 'radiolabelfullwidth'" class="input-field radiolabel" v-show="field.enabled">
                     <label :for="field.name" v-html="field.displayName"></label>
                        <table>
                            <thead>
                              <tr>
                                  <th :width="(99.99 / (field.values.length)).toFixed(2) + '%'" v-for="(item, index) in field.radioHeaderOptions" v-bind:key="index">{{item}}</th>
                              </tr>
                            </thead>
                            <tbody class="input-field newRadio">
                                <tr> 
                                  <td :width="(99.99 / (field.values.length)).toFixed(2) + '%'" v-for="(item, index) in field.values" v-bind:key="index" class="radio">
                                    <label  class="container">
                                      <input
                                        type="radio"
                                        :value="item.value"
                                        :id="item.value"
                                        v-model="field.value"
                                      />
                                      <span class="checkmark"></span>
                                      <input  :id="item.value + '_other'" v-model="field.commentValue" type="text" placeholder="Enter your comment here..." v-if="item.name == 'Other' && field.value && field.value.includes('Comments')" />
                                    </label>
                                  </td>
                                </tr>
                              </tbody>
                        </table>
                    </div>
                   
                    <div v-if="field.type == 'radiolabel'" class="input-field radiolabel" v-show="field.enabled">
                     <label :for="field.name" v-html="field.displayName"></label>
                        <table>
                            <thead>
                              <tr>
                                  <th width=50%>&nbsp;</th>
                                  <th :width="(99.99 / (field.values.length)).toFixed(2) + '%'" v-for="(item, index) in field.radioHeaderOptions" v-bind:key="index">{{item}}</th>
                              </tr>
                            </thead>
                        </table>
                    </div>

                   <table v-if="field.type == 'radio'" class="input-field newRadio" v-show="field.enabled">
                     <div v-show="field.comments">
                        <input :id="field.name + '_comments'" :name="field.name + '_comments'" v-model="field.commentValue" type="text"  />
                        
                      </div>
                      
                     <thead>
                          <tr>
                            <th width=50%>&nbsp;</th>
                            <th class="input-label newRadioLabel" :width="(49.99 / (field.values.length)).toFixed(2) + '%'" v-for="(item, index) in field.values" v-bind:key="index">{{item.value}}</th>
                          </tr>
                     </thead>
                      <tbody>
                        <tr>
                          <td width=50%><label :for="field.name">{{field.displayName}}</label></td>
                          <td :width="(49.99 / (field.values.length)).toFixed(2) + '%'" v-for="(item, index) in field.values" v-bind:key="index" class="radio">
                             <label  class="container">
                              <input
                                type="radio"
                                :value="item.value"
                                :id="item.value"
                                v-model="field.value"
                              />
                              <span class="checkmark"></span>
                               
                                <!-- <input  :id="item.value + '_other'" v-model="field.commentValue" type="text" placeholder="Enter your comment here..." v-if="item.name == 'Other' && field.value && field.value.includes('Comments')" /> -->
                             </label>
                          </td>
                        </tr>
                      </tbody>
                      
                    </table>
                    
                    <div v-if="field.type == 'questionlabel'" class="input-field" v-show="field.enabled">
                      <label :for="field.name"  class="questionlabel">
                        For questions 1 to 6, please indicate your response by <span style="color:#473192"><b><u>using the sliding scale bar</u></b></span> to choose your option indicated below:<br/><br/>
                      <div class="coloured">A. Strongly Agree<br/>B. Agree<br/>C. No strong view / Unsure<br/>D. Disagree<br/>E. Strongly Disagree</div>
                      <div class="coloured question-instructions">Please click and drag the letter roundel to indicate your choice.</div>
                      </label>
                    </div>
                    <div v-if="field.type == 'label'" class="input-field" v-show="field.enabled">
                      <label class="label-blue" :for="field.name" v-html="field.displayName" ></label>
                    </div>
                    <div v-if="field.type == 'labelBold'" class="input-field" v-show="field.enabled">
                      <label class="label-blue label-bold" :for="field.name" v-html="field.displayName" ></label>
                    </div>
              
                    <div v-if="field.type == 'geojson'" class="input-field button-group" v-show="field.enabled">
                      <button
                                v-if="!isIteractingMap(field.name)"
                                @click.prevent="registerMapInteraction(field.name,field.type,field.values.options,field)"
                              >{{field.displayName}}</button>
                      <button
                                v-if="isIteractingMap(field.name)"
                                @click.prevent="deRegisterMapInteraction(field.name,field.type)"
                              >Stop Edit</button>
                               <div v-if="isIteractingMap(field.name)" class="pinDropHelp">Please use the buttons at the top right of the map to add or remove your pins</div>
                      <Editable
                                v-if="field.values != undefined ? field.values.showCode : true"
                                :id="field.name"
                                v-model="field.value"
                              ></Editable>
                    </div>
                   
                    <div v-if="field.type == 'json'" class="input-field" v-show="field.enabled">
                      <Editable
                                v-if="field.values != undefined ? field.values.showCode : true"
                                :id="field.name"
                                v-model="field.value"
                              ></Editable>
                    </div>
                    <div v-if="field.type == 'color'" class="input-field" v-show="field.enabled">
                      <label :for="field.name">{{field.displayName}}</label>
                      <Chrome :id="field.name" v-model="field.value" />
                     
                    </div>
                     <div v-if="field.type=='postcode'" class="input-field" v-show="field.enabled">
                      <label :for="field.name">{{field.displayName}}</label> <span class="" v-if="field.requiredField" style="color: red;font-size: 1.5rem;font-weight: 500;">*</span>
                      <input :id="field.name" type="text" v-model="field.value">
                    </div>
                    <div v-if="field.type == 'textarea'" class="input-field" v-show="field.enabled">
                      <label :for="field.name" class="thicklabel">{{field.displayName}}</label>
                      <span class="required" v-if="field.requiredField">*</span>
                      <textarea :id="field.name" type="text" v-model="field.value"></textarea>
                    </div>
                    <div v-if="field.type == 'entityLink'" class="input-field" v-show="field.enabled">
                      <label :for="field.name">{{field.displayName}}</label>
                      <div class="input-field--nested">
                        <label :for="field.name+'-name'">Name</label>
                        <input :id="field.name+'-name'" type="text" v-model="field.value.name" />
                      </div>
                      <div class="input-field--nested">
                        <label :for="field.name + '-value'">Url</label>
                        
                        <input :id="field.name+ '-value'" type="text" v-model="field.value.url" />
                      </div>
                    </div>
                   
                    <div v-if="field.type == 'html'" class="input-field" v-show="field.enabled">
                      <label :for="field.name">{{field.displayName}}</label>
                      <textarea :id="field.name" type="text" v-model="field.value"></textarea>
                    </div>
                    <div v-if="field.type == 'files'" class="input-field" v-show="field.enabled">
                      <label>{{field.displayName}}</label>
                      <div id="fileListing">
                        <table v-if="(field.value != undefined ? field.value : 0) != 0">
                          <thead>
                            <tr>
                              <th>Name</th>
                              
                              <th>Delete</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item,i) in field.value" :key="i">
                              <td v-if="!item.uploaded">
                                <div class="uploader">
                                  <span :title="item.name">{{item.name}}</span>
                                  <span :style="'width:' + item.progress + '%'"></span>
                                </div>
                              </td>
                              <td v-if="item.uploaded">
                                <a :href="item.url" _target="blank">
                                  <span :title="item.name">{{item.name}}</span>
                                </a>
                              </td>
                             
                              <td v-if="item.uploaded" @click.prevent="removeFromlist(field.value,item)">
                                <i title="Click to delete" class="material-icons">delete</i>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="file-field input-field">
                          <div class="btn custom-btn">
                            <span>Click here to select files</span>
                            <input
                                      @change="updateFileList(field.name)"
                                      type="file"
                                      :ref="field.name"
                                      multiple
                                    />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="field.type == 'readonly'" class="input-field" v-show="field.enabled">
                      <label :for="field.name">{{field.displayName}}</label>
                      <input readonly :id="field.name" type="text" v-model="field.value" />
                      <input
                                readonly
                                :id="field.name"
                                type="text"
                                :model="userLink(field.value)"
                                v-if="field.name=='createdBy'"
                              />
                    </div>
                   
                  </div>
                </div>
              </div>
            </li>
          </ul>
          
        </div>
      </form>

  
          </div>
        </stepper>
      </div>  
  
    </div>
    <div class="bottom-fixed">
      <button
        v-if="deleteEnabled"
        class="deleteButton"
        :title="'Delete'"
        v-confirm="{
                  loader: true,
                  ok: dialog => deleteData(dialog),
                  cancel: doNothing,
                  message: 'Are you sure you want to delete?'}"
      >
        <i class="material-icons">delete</i>
      </button>
      <button @click.prevent="dismissUploadForm()" title="Cancel Editing" class="cancelButton" v-if="type && type.type !== 'feedback'">
        <i class="material-icons">clear</i>
      </button>
      <button @click.prevent="saveData('save')" title="Save" :class="{'saveButton': type && type.type !== 'feedback'}" v-if="!loading && curStepFeedbackForm==2">
        <i class="material-icons" v-if="type && type.type !== 'feedback'">save</i>
        <span v-else>Submit Feedback</span>
      </button>
      <button title="Save" class="saveButton disabled" v-if="loading">
        <i class="material-icons">hourglass_full</i>
      </button>
      <!-- <img src="@/assets/images/loading.png" v-if="!loading" style="width: 30px;margin-left:20px;"> -->
      <button
        @click.prevent="saveData('submit')"
        v-show="showSubmit"
        v-if="canSubmit"
      >{{ nextStep }}</button>
    </div>

    <MapKey />
    <!-- <SatView /> -->
  </div>
</template>

<script>
import shaw from '@/assets/images/SHAWS-WM.png';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
import Settings from "@/mixins/AppSettings.js";
import { mapState, mapGetters } from "vuex";
import Apicall from "../mixins/Apicall";
import { Chrome } from "vue-color";
import _ from "lodash";
import Datepicker from "vuejs-datepicker";
import Editable from "@/components/Editable";
import vueRange from "@/components/Range";
import firebase from "firebase";
import MapKey from "@/components/MapKey";
import SatView from "@/components/SateliteViewToggle";
import HorizontalStepper from 'vue-stepper';
import Stepper from '@/components/FormStepper';
export default {
  name: "EntityEdit",
  mixins: [],
  components: {
    Chrome,
    VueSlider,
    Datepicker,
    Editable,
    vueRange,
    MapKey,
    SatView,
    HorizontalStepper,
    Stepper
  },
  data() {
    return {
     counterForPins:0,
      steps: [
    { id:1,label: '  ',slug:'step1' },
    { id:2,label: '    ',slug:'step2' }
   
  ],
     
       vueSliderOptions: {
      data:['A', 'B', 'C', 'D', 'E'],
       value:'A',
       height: 15,
       dotSize: 32,
       clickable: false,
       tooltip: 'always',
       processStyle: {
           backgroundColor: '#9e9e9e'
       },
       dotStyle: {
           backgroundColor: '#fc3'
       }
     },
      type: undefined,
      loading: false,
      formFields: [],
      types: [],
      parent: this.$route.params.id,
      mapInteractions: [],
      listOfFiles: [],
      uploadList: [],
      uploadobj: {},
      deleteList: [],
      currentFileItem: undefined,
      deleteEnabled: false,
      showSubmit: false
    };
  },
  created() {
    
  },

  beforeDestroy() {},
  async mounted() {
    let results = await Apicall.getfirebaseCollectionAll("entityTypes");
    if (this.entities.length == 0) {
      await this.$store.dispatch("populateEntities");
    }

    //console.log("types", results);
    if (this.$route.params.operation) {
      if (this.$route.params.operation == "edit") {
        this.deleteEnabled = true;
        this.showSubmit = true;
      }
    }

    for (let item of results) {
      if (this.$route.params.type) {
        if (this.$route.params.type == item.type)
          this.addGroup(item, this.$route.params.operation);
      } else {
        this.types.push(item);
      }
    }

    this.$nextTick(() => {
      let selectElems = document.querySelectorAll("select");
      let selectInstances = M.FormSelect.init(selectElems, {});
        let elems = document.querySelectorAll('.collapsible');
        let instances = M.Collapsible.init(elems, {
          accordion: false
        });
    });
  },
  computed: {
    ...mapState(["entities"]),
    ...mapGetters([
      "curStepFeedbackForm",
      "entityByDocId",
      "entityByType",
      "entityParentByChild",
      "entityByParent",
      "entityTypeByType",
      "entityTypesByParentType",
      "user",
      
    ]),
    // reverseMessage: function (userEmail) {
    //   console.log('userEmail',userEmail);
    //   return userEmail;
    // },
   
    canSubmit() {
      let editEntity = this.entityByDocId(this.$route.params.id)[0];
      if (editEntity && this.type) {
        if (editEntity.state == "default") {
          return false;
        }

        if (this.type.states) {
          let currentState = this.type.states.find(item => {
            return item.name == editEntity.state;
          });

          return currentState.role.indexOf(this.user.role) != -1;
        } else {
          return false;
        }
      }
    },

    nextStep() {

      let currentStepObj = this.formFields.filter(
        obj => obj.displayName == "State"
      );
      if (
        currentStepObj.length > 0 &&
        currentStepObj[0].displayName == "State"
      ) {
        if (currentStepObj[0].value !== "default") {
          let currStep = this.type.states.filter(
            state => state.name == currentStepObj[0].value
          );
          // this.showSubmit = true;
          return currStep[0].submitDesc;
        } else {
          this.hideSubmit = false;
          return "Submit";
        }
      } else {
        this.hideSubmit = false;
        return "Submit";
      }
    },
   fieldGroupsFilterSlug() {

     
      if(this.type.hasOwnProperty('fieldGroups') && this.type.fieldGroups.length > 0) {
       
        let slug = this.steps.filter(obj=>obj.id==this.curStepFeedbackForm);
       
        console.log('Slug::',slug)
          let currentStepObj = this.type.fieldGroups.filter(
            newObj => newObj.step == slug[0].slug
          );
          console.log('currentObj',currentStepObj)
          return _.orderBy(currentStepObj, ['order'], ['asc'])
      } else {
        return [{
          name:"default",
          order: -999,
          remove: true,
          show: false,
          slug:"default"
        }];
      }
    },
    fieldGroups() {
      if(this.type.hasOwnProperty('fieldGroups') && this.type.fieldGroups.length > 0) {
        return _.orderBy(this.type.fieldGroups, ['order'], ['asc']);
      } else {
        return [{
          name:"default",
          order: -999,
          remove: true,
          show: false,
          slug:"default"
        }];
      }
    }
  },

  watch: {
    // Deep watch form fields
    formFields: {
      deep: true,
      handler: function (newVal, oldVal) {
        if(this.type && this.type.type == "feedback") {
          console.log('watch fired');
          //alert('watch')
          const ValuesToWatch=['all','North','South','g2']
          const questionWatch='routes'
          const northRoutes=[ 'northRouteAntrimRoadComments','northRouteShoreRoadAComments','northRouteShoreRoadBComments']
          const southRoutes=[ 'southRouteComments']
          const g2=[ 'g2ExtentionComments']
          const all=[ 'southRouteComments','g2ExtentionComments','northRouteAntrimRoadComments','northRouteShoreRoadAComments','northRouteShoreRoadBComments',]
          
           this.feedbackShowHideQuestions(newVal, questionWatch, ValuesToWatch, all);
          
         
        }

      }
    },
    
    curStepFeedbackForm(val, oldVal) {
        // is triggered whenever the store state changes
        // alert('do stuff', val, oldVal);
    }
    
  },
  methods: {
  
    countGroupFields(slug, formFields) {

      let ignoreFields = "createdBy,state"; 
      let groupFormFields = this.groupFormFields(slug, formFields)
      let filteredGroupFormFields = groupFormFields.filter((item) => {return ignoreFields.indexOf(item.name) == -1});
      let amountComplete = filteredGroupFormFields.filter((item)=> {return item.value != undefined && item.value != ""}).length;
      let numberOfQuestions =  filteredGroupFormFields.length;
      return amountComplete + "/" + numberOfQuestions;
    },
    showHideGroups(groupSlug, formFields) {
      // Get Fields Filtered By Group.
      let filteredFields = this.groupFormFields(groupSlug, formFields);
      if(filteredFields && filteredFields.length > 0) {
        let value = false;
        for (let item in filteredFields) {
          if (filteredFields[item].enabled == true) {
            value = true;
            break;
          }
        }
        return value;
      } else {
        return false;
      }
    },
    groupFormFields(groupSlug, formFields) {
      let fields = formFields.filter(field => field.group === groupSlug );
      return fields;
    },
    feedbackShowHideQuestions(newFormFields, questionToWatch, valueToWatch, relationArray) {
      console.log(newFormFields, questionToWatch, valueToWatch, relationArray);

     const newArrayList=[]
      // Get Targeted Question
      let question = newFormFields.find((el) => {
        return el.name == questionToWatch
      });
      if(question.value.length>0){

         question.value.forEach((item, index) => {
           
            switch (item) {
              
              case "North":
               
                newArrayList.push('northRouteAntrimRoadComments','northRouteShoreRoadAComments','northRouteShoreRoadBComments')
                break;
              case "South":
              
                newArrayList.push('southRouteComments')
                break;
              case "g2":
                
                newArrayList.push('g2ExtentionComments')
                break;
              case "all":
                
                newArrayList.push('southRouteComments','g2ExtentionComments','northRouteAntrimRoadComments','northRouteShoreRoadAComments','northRouteShoreRoadBComments')
                break;
              default:
                
                newArrayList.push('')
            }
            console.log(newArrayList)
         })
      }

      // Loop Through Related Questions And Check If Targeted Question Has Been Set The Correct Value
      // To Show/Hide The Related Questions.
      let relation = relationArray;
      relation.forEach((item, index) => {
        let relQuestion = newFormFields.find((el) => {
          return el.name == item
        });
        
        if(relQuestion !== undefined) {
          let valueisThere=newArrayList.includes(item)
          console.log(valueisThere, question.value[0])
          if(valueisThere == true ) {
            relQuestion.enabled = true
          } else {
            relQuestion.enabled = false;
          }
        }
      });
    
      
      //debugger
      console.log(newFormFields)
      // Push The Updated Form Fields To The View.
       this.formFields = newFormFields;
    },
    setDefaultValuesOnSave(type) {
      let defaultValue = undefined;
      if (type == "checkbox" || type == "dropdowns" || type == "checkboxbutton" ) {
        defaultValue = [];
      }
      if (type == "json") {
        defaultValue = "{}";
      }
      if (type == "entityLink") {
        defaultValue = { name: "", url: "" };
      }
      if (type == "video") {
        defaultValue = { autoplay: false, url: "" };
      }
      if (type == "color") {
        defaultValue = "#194d33";
      }
      if (type == "dropdown") {
        defaultValue = undefined; //type.fields[field].values[0];
      }
      if (type == "rank") {
        defaultValue = 0;
      }
      return defaultValue;
    },
    toggleHelper(instance) {
      console.log(this.$refs[instance]);
      this.$refs[instance][0].classList.toggle("helper-msg--show");
    },
    parentLink: function(existingParentId, displayType) {
      var nextPage = "/" + "map/entity/";
      let parentId = this.$route.params.id;
      let parent = this.entities.filter(parent => {
        return parent.docId == parentId;
      });

      if (displayType == "Parent") {
        return parent[0].name;
      } else if (displayType == "Link") {
        return nextPage + parent[0].docId;
      }
    },
    userLink: function(userEmail, displayType) {
      let user = this.entities.filter(user => {
        return user.properties.email == userEmail;
      });
      var nextPage = "/" + "users/entity/";
      var back = "?" + "browseHistory=" + this.$route.params.type;
      if (displayType == "UserName") {
        return user[0].name;
      } else if (displayType == "Link") {
        return nextPage + user[0].docId + back;
      }
    },
    isMobileDevice() {
      if (window.innerWidth < 1366) {
        return true;
      } else {
        return false;
      }
    },
    updateHidden(field) {
      let editor = this.$refs[field + "-edit"];

      //let hiddenElement = document.getElementById(field);

      let hiddenElement = this.$refs[field];

      let hiddenFormField = this.formFields.find(item => {
        return item.name == field;
      });

      hiddenFormField.value = editor[0].innerText;
      // debugger
    },
    doNothing() {},
    updateFileList(name) {
      let files = this.$refs[name][0].files;

      let uploadList = [];

      let filesField = this.formFields.find(item => {
        return item.type == "files" && item.name == name;
      });

      if (filesField.value) {
        uploadList = filesField.value.filter(item => {
          return item.uploaded == true;
        });
      }

      // fileCount = uploadList.length

      let fileCount = 0;

      for (var file of files) {
        let uploadobj = {};

        uploadobj["name"] = file.name;
        uploadobj["type"] = file.type;
        uploadobj["url"] = "";
        uploadobj["progress"] = 0;
        uploadobj.uploaded = false;
        uploadobj.fileIndex = fileCount;
        uploadList.push(uploadobj);

        fileCount++;
      }

      filesField.value = uploadList;
    },
    uploadFile(file, resolve, reject) {
      var self = this;
      const name = +new Date() + "-" + file.name;
      const metadata = { contentType: file.type };
      const ref = firebase.storage().ref();
      const fileref = ref.child(name);
      const task = ref.child(name).put(file, metadata);

      task.on(
        "state_changed",
        function(snapshot) {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          //console.log("Upload is " + progress + "% done");

          self.currentFileItem.progress = Math.round(progress);
          //uploadProgress.style.width = Math.round(progress * 2) + 'px';
        },
        function(error) {
          // Handle unsuccessful uploads
        },
        function() {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          task.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            //console.log(downloadURL);

            self.currentFileItem.uploaded = true;
            self.currentFileItem.url = downloadURL;
            self.processUploadList(resolve, reject);
          });
        }
      );
    },
    async startProcessList() {
      return new Promise((resolve, reject) => {
        this.processUploadList(resolve, reject);
      });
    },

    processUploadList(resolve, reject) {
      let filesFields = this.formFields.filter(item => {
        return item.type == "files";
      });

      if (filesFields.length == 0) {
        resolve();
      }

      for (let fileField of filesFields) {
        if (fileField.value) {
          this.currentFileItem = fileField.value.find(item => {
            return item.uploaded == false;
          });
        }

        if (this.currentFileItem != undefined) {
          let file = this.$refs[fileField.name][0].files[
            this.currentFileItem.fileIndex
          ];
          this.uploadFile(file, resolve, reject);
        } else {
          resolve();
        }
      }
    },
    removeFromlist(files, item) {
      //debugger
      this.deleteList.push({ url: files[item.fileIndex].url });
      files.splice(item.fileIndex, 1);
      M.toast({
        html: "File removed, Please submit to update.",
        classes: "rounded"
      });
    },
    isIteractingMap(eventSource, type) {
      return this.mapInteractions.find(item => {
        return item.eventSource == eventSource;
      });
    },
    removeGeoJson(field)
    {
      field.value = undefined;

        let features = [];
        let mapFields = this.formFields.filter((item) => {return item.type == "geojson"})
        for(let field of mapFields)
        {
          if(field.value)
          {
          let parsedJson = JSON.parse(field.value)
          features.push(...parsedJson.features);
          }
        }

         let geojson = {
            type: "FeatureCollection",
            features: features,
          };

      this.$root.$emit("refreshMap", this.mapInteractions, true,undefined,geojson);
    },

    deRegisterMapInteraction(eventSource, type) {
      this.mapInteractions.pop({ eventSource: eventSource, type: type });

      let updateMap = true;


      if(this.$route.params.operation != "edit")
      {
        
        let features = [];
        let mapFields = this.formFields.filter((item) => {return item.type == "geojson"})
        for(let field of mapFields)
        {
          if(field.value)
          {
          let parsedJson = JSON.parse(field.value)
          features.push(...parsedJson.features);
          }
        }

         let geojson = {
            type: "FeatureCollection",
            features: features,
          };
          
         this.$root.$emit("refreshMap", this.mapInteractions, updateMap,undefined,geojson);
      }
      else
      {
            this.$root.$emit("refreshMap", this.mapInteractions, updateMap);
      }

    
      this.$root.$off(eventSource, this.handleRefreshCoords);
    },
    registerMapInteraction(eventSource, type, options, field) { 
      this.counterForPins++
      if(field.value!=undefined){
           this.$root.$on(eventSource, this.handleRefreshCoords);
      }
      
      let drawOptions = {};
      if (options) {
        drawOptions = JSON.parse(options);
      }

      if(options.defaultControl)
      {
        for(let currentIteration of this.mapInteractions)
        { 
          this.deRegisterMapInteraction(currentIteration.eventSource,currentIteration.type); 
        }
        
        drawOptions = {"displayControlsDefault": false, "controls":{},defaultControl: "draw_point"};
      }

      this.mapInteractions.push({ eventSource: eventSource, type: type });
      let updateMap = true;
      this.$root.$emit(
        "refreshMap",
        this.mapInteractions,
        updateMap,
        drawOptions
      );
      
      
      this.$root.$on(eventSource, this.handleRefreshCoords);
    },
    handleRefreshCoords(eventSource, updatedGeoJson) {
      let geoJsonField = this.formFields.find(item => {
        return item.name == eventSource;
      });

      let currentControl = this.formFields.find((item) => {return item.name == eventSource})

if(updatedGeoJson.features.length>5){
  //  stop if pins are more than 5
  //alert('stop')
}else{

// Only if there is 5 pins
      for (let feature of updatedGeoJson.features) {
        let updatedProperties = {};
        for (let property in feature.properties) {
          if (
            property != "docId" &&
            property != "name" &&
            property != "parent" &&
            property != "type" &&
            property != "show" &&
            property != "children"
          ) {
            updatedProperties[property] = feature.properties[property];
          }
        }

        feature.properties = updatedProperties;
        
        if(currentControl.values.name)
        {
          feature.properties.name = currentControl.values.name;
        }
        else
        {
          feature.properties.name = "";
        }

      }

      geoJsonField.value = JSON.stringify(updatedGeoJson, null, 4);

}
      
      //console.log('TEST Geo Json !!',geoJsonField.value)
      // if(currentControl.values.options.indexOf("defaultControl") != 4)
      // {alert('in')
      //     this.deRegisterMapInteraction(eventSource,currentControl.type);
      // }
     


      
    },
    string_to_slug(str) {
      str = str.replace(/^\s+|\s+$/g, ""); // trim
      str = str.toLowerCase();

      var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaeeeeiiiioooouuuunc------";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }

      str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-"); // collapse dashes

      return str;
    },
    addGroup(type, operation) {
      this.type = type;

      this.formFields.push({
        order: 5,
        name: "name",
        type: "string",
        value: undefined,
        displayName: "Name",
        requiredField: false,
        enabled: true,
        group: 'about',
        comments:false,
        commentValue:''
      });

      this.formFields.push({
        order: -1,
        name: "state",
        type: "hidden",
        value: undefined,
        displayName: "State",
        requiredField: true,
        enabled: true,
        group: 'default',
        comments:false,
        commentValue:''
      });

      this.formFields.push({
        order: 999,
        name: "createdBy",
        type: "userLink",
        value: undefined,
        displayName: "Created By",
        requiredField: false,
        enabled: true,
        group: 'default',
        comments:false,
        commentValue:''
      });
      // this.formFields.push({
      //   order: 3,
      //   name: "parent",
      //   type: "parentLink",
      //   value: this.$route.params.id,
      //   displayName: "Parent Site",
      //     requiredField: true
      // });

      if (operation == "addentity") {
        let defaultState = "default";
        if (type.states) {
          defaultState = type.states[0].name;
        }

        this.formFields.find(item => {
          return item.name == "state";
        }).value = defaultState;

        this.formFields.find(item => {
          return item.name == "createdBy";
        }).value = this.user?this.user.email: undefined;
      }

      let editEntity = {};
      if (operation == "edit") {
        editEntity = this.entityByDocId(this.$route.params.id)[0];

        if (editEntity.parent != "null" && Settings.parentChange) {
          let parentItem = this.entityByDocId(editEntity.parent)[0];

          let parentTypes = this.entityTypesByParentType(
            parentItem.type
          ).filter(item => {
            return item.type != editEntity.type;
          });
          let combinedParents = [];
          combinedParents = combinedParents.concat(
            this.entityByType(parentItem.type)
          );
          combinedParents = _.orderBy(combinedParents, "name");

          for (let parentType of parentTypes) {
            let foundParents = this.entityByType(parentType.type);
            combinedParents = combinedParents.concat(foundParents);
          }

          let listItems = [];
          for (let item of combinedParents) {
            listItems.push({ name: item.name, value: item.docId });
          }

          listItems = _.orderBy(listItems, "name");

          this.formFields.push({
            order: -1,
            name: "parent",
            type: "dropdown",
            value: editEntity.parent,
            values: listItems,
            displayName: "Parent"
          });
        }

        this.formFields.find(item => {
          return item.name == "name";
        }).value = editEntity.name;

        this.formFields.find(item => {
          return item.name == "state";
        }).value = editEntity.state;

        this.formFields.find(item => {
          return item.name == "createdBy";
        }).value = editEntity.createdBy;
      }

      for (let field in type.fields) {
        let defaultValue = undefined;

        if (operation == "edit") {
          defaultValue = editEntity.properties[field];
        } else {
          if (
            type.fields[field].type == "checkbox" ||
            type.fields[field].type == "checkboxbutton" ||
            type.fields[field].type == "dropdowns" 
          ) {
            defaultValue = [];
          }

          
          if (type.fields[field].type == "json") {
            defaultValue = "{}";
          }


          if (type.fields[field].type == "entityLink") {
            defaultValue = { name: "", url: "" };
          }

          if (type.fields[field].type == "video") {
            defaultValue = { autoplay: false, url: "" };
          }

          if (type.fields[field].type == "color") {
            defaultValue = "#194d33";
          }

          if (type.fields[field].type == "dropdown") {
            defaultValue = undefined; //type.fields[field].values[0];
          }

          if (type.fields[field].type == "rank") {

            
           
            if(type.fields[field].values.defaultValue != undefined)
            {
              //  debugger
              defaultValue = type.fields[field].values.defaultValue;
            }
            else
            {
               defaultValue = Math.round(type.fields[field].values.maxValue / 2);
            }
           
          }

          if (type.fields[field].type == "id") {
            for (let value of type.fields[field].values) {
              if (value == "{parent}") {
                let parentName = this.entityByDocId(this.$route.params.id)[0]
                  .name;
                if (defaultValue == undefined) {
                  defaultValue = parentName;
                } else {
                  defaultValue = defaultValue + "/" + parentName;
                }
              } else if (value == "{autoid}") {
                let parentEntities = this.entityByParent(this.$route.params.id);

                let nextId = (parentEntities.length + 1).toString();

                if (defaultValue == undefined) {
                  defaultValue = nextId;
                } else {
                  defaultValue = defaultValue + "/" + nextId;
                }
              }
            }
          }
        }

        this.formFields.push({
          order: type.fields[field].order,
          name: field,
          type: type.fields[field].type,
          displayName: type.fields[field].displayName,
          value: defaultValue,
          values: type.fields[field].values,
          requiredField: type.fields[field].requiredField,
          helpField: type.fields[field].help,
          enabled: type.fields[field].visible,
          group: type.fields[field].group ? type.fields[field].group[0] : 'default',
          comments:type.fields[field].comments ? type.fields[field].comments : false,
          commentValue:'',
          radioHeaderOptions:type.fields[field].radioHeaderOptions ? type.fields[field].radioHeaderOptions : ''
        });

        this.formFields = _.orderBy(this.formFields, "order");
      }
    },

    dismissUploadForm() {
      // 1. Go back to search functionality.
      // 2. Destroy all post data related to form

      if (this.$route.params.id) {
        this.$router.push(
          "/" + this.$route.params.root + "/entity/" + this.$route.params.id
        );
      } else {
        this.$router.push("/map");
      }
    },
    async deleteData(dialog) {
      dialog.close();

      let editEntity = this.entityByDocId(this.$route.params.id)[0];
      this.parent = editEntity.parent;

      let fileList = [];

      for (let field of this.formFields) {
        if (field.type == "files") {
          if (field.value) {
            for (let file of field.value) {
              fileList.push(file);
            }
          }
        }
      }

      for (let item of fileList) {
        await Apicall.deleteFromFirebase(item.url);
      }

      //TODO: create a better generic way of doing extra stuff around entitiy save
      if (this.type.type == "user") {
        let result = await Apicall.deletefirebaseUser(
          editEntity.properties.uid
        );
        if (!result.updated) {
          alert(result.message.message);
          return;
        }
      }

      let results = await Apicall.deletefirebaseCollection(
        "entities",
        this.$route.params.id
      );
      //console.log(results);

      await this.$store.dispatch("populateEntities");
      //await this.$store.dispatch("populateEntityTypes");

      let nextPage = "/" + this.$route.params.root + "/";

      if (this.parent) {
        nextPage =
          "/" + this.$route.params.root + "/" + "entity/" + this.parent;
      }

      setTimeout(() => this.$router.push(nextPage), 1000);
    },
    async saveData(saveType) {
      console.log("SAVING", saveType, this.formFields, this.curStepFeedbackForm);
      this.loading = true;
      await this.startProcessList(); //Process files

      let properties = {};
      let errors = [];

      let name = "";
      let state = "";
      let createdBy = "";

      // Set default values to 'enabled: false' values
      for (let field of this.formFields) {
        if(field.enabled == false) {
          // console.log('old',field.value);
          field.value = this.setDefaultValuesOnSave(field.type);
          // console.log('new', field.value)
        }
      }

      for (let field of this.formFields) {//alert('tt')
         if (field.requiredField && (field.value == "" || field.value == undefined) ) {
          errors.push("<b>" + field.displayName + "</b> is required");
        }

        if (field.type == "label") {
          properties[field.name] = "";
        } else if (field.name == "name") {
          name = field.value;
        } else if (field.name == "parent") {
          parent = field.value;
          // properties[field.name]=field.value;
        } else if (field.name == "state") {
          state = field.value;
        } else if (field.name == "createdBy") {
          createdBy = field.value;
        }else if (field.type == "radio" || field.type == "checkbox") {
          console.log(field,field.type,field.value, field.commentValue,field.commentValue.value, properties[field.name + '_comments'])
          // if(field.value){
          //   if(field.value.includes('Comments')){
          //      properties[field.name + '_otherComments'] = field.commentValue
          //   }
             
          // }
          if(field.value){
            if(field.comments==true){
                properties[field.name + '_otherComments'] = field.commentValue 
            }
          }
          properties[field.name]=field.value
          //properties[field.name+'comments']=field.value
          //debugger;
          // createdBy = field.value;
        }else if (field.type == "checkboxbutton") {
          // if(field.value>=5){
          //     errors.push("<b>" + field.displayName + "</b> will only accept 5 values");
          // }else{
             properties[field.name]=field.value
          //}
            console.log('Checkbox',field.value);
        }else {
          if (field.type == "color" && field.value.hex) {
            properties[field.name] = field.value.hex;
          } else {
            properties[field.name] = field.value;
          }
        }
        
      }

      if (errors.length != 0) {
        let errorMessage = "<ul>";

        for (let error of errors) {
          errorMessage += "<li>" + error + "</li>";
        }

        M.toast({
          html: errorMessage,
          classes: "rounded"
        });
        this.loading = false;
        console.log(errors);
        return;
      }

      //TODO: create a better generic way of doing extra stuff around entitiy save

      if (this.type.saveCollection) {
        console.log("Coll", properties);

        let parentId = this.$route.params.id;
        let parent = this.entities.find(parent => {
          return parent.docId == parentId;
        });
         console.log('UUU',this.user)
        properties["name"] = name;
        properties["dateSubmitted"] = new Date().toUTCString();
        properties["userEmail"] = this.user?this.user.email:'';
        properties["userName"] = this.user?this.user.name:'';
        properties["parentId"] = parentId;
        properties["parentName"] = parent.name;

        //  debugger;

        let result = await Apicall.addfirebaseCollection(
          this.type.saveCollection,
          properties
        );

        let nextPage = "/" + this.$route.params.root + "/";
        if (this.parent != "null") {
          nextPage =
            "/" + this.$route.params.root + "/" + "entity/" + this.parent;
        }
        
        setTimeout(() => {
          this.loading = false;
           this.$store.commit("setCurStepFeedbackForm",1 );
          this.$router.push('/site/thankYou');
        }, 1000);

        return;
      }

      if (this.type.type == "user") {
        properties.email = properties.email.toLowerCase();

        let userUpdateObject = {
          uid: properties.uid,
          displayName: name,
          email: properties.email,
          password: properties.password,
          role: properties.role
        };
        let result = await Apicall.updatefirebaseUser(userUpdateObject);
        if (!result.updated) {
          alert(result.message.message);
          return;
        } else {
          properties.uid = result.data.uid;
          properties.password = undefined;
        }
      }

      for (let item of this.deleteList) {
        await Apicall.deleteFromFirebase(item.url);
      }

      if (this.$route.params.operation == "edit") {
        let editEntity = this.entityByDocId(this.$route.params.id)[0];

        this.parent = editEntity.parent;
        let data = {
          name: name,
          state: state,
          createdBy: createdBy,
          properties: properties,
          slug: this.string_to_slug(name),
          type: this.type.type,
          parent: editEntity.parent
        };

        let results = await Apicall.updatefirebaseCollection(
          "entities",
          this.$route.params.id,
          data,
          saveType
        );
        //console.log(results);
      } else {
        let data = {
          name: name,
          state: state,
          createdBy: createdBy,
          properties: properties,
          slug: this.string_to_slug(name),
          type: this.type.type,
          parent: this.parent
        };
        let results = await Apicall.addfirebaseCollection(
          "entities",
          data,
          saveType
        );
        console.log(results);
      }
      // this.loading=false;
      let nextPage = "/" + this.$route.params.root + "/";
      if (this.parent != "null") {
        nextPage =
          "/" + this.$route.params.root + "/" + "entity/" + this.parent;
      }

      await this.$store.dispatch("populateEntities");
      await this.$store.dispatch("populateEntityTypes");

      setTimeout(() => {
        this.loading = false;
        this.$router.push(nextPage);
      }, 1000);
    }
  }
};
</script>